




































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DataDokter from "@/services/DataUtility";
import DataSpri from "@/services/DataSpri";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import Tanggal from "../Tanggal.vue";
import { identity } from "lodash";
import { userModule } from "@/store/modules/user";
import { storeSpri } from "@/store/modules/spri";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalSpri extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  // @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() dataSoap: object;
  @Prop() dpjp: object;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  dtSpri: object = {};
  sess_login = userModule.user;
  listDokter: object = {};
  tanggal = new Date().toISOString().substr(0, 10);
  keluhan_utama = "";
  riwayat_penyakit = "";
  pemeriksaan_fisik = "";
  pemeriksaan_penunjang = "";
  diagnosis = "";
  terapi = "";
  // dokter_id = this.sess_login["user"].id;
  // today= new Date().toISOString().substr(0, 10)
  soap: object = {};
  modalTtd = false;

  // author_id=""
  // unit_id=""

  get dialog() {
    // console.log(this.value);

    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }
  mounted() {
    this.dokterList();
    // this.soap = this.dataSoap;
    // console.log("so", this.soap);
    // this.getSpri()

    // console.log('dtsoap ',this.getSoap())
  }
  @Watch("register")
  change(val, oldval) {
    this.register = val;
  }
  @Watch("dataSoap")
  changeSOAP(value) {
    // console.log("dtspri", value);
    // if (value == undefined) {
    this.soap = value;
    this.keluhan_utama = this.soap["keluhan_utama"];
    this.pemeriksaan_penunjang = this.soap["pemeriksaan_penunjang"];
    this.riwayat_penyakit = this.soap["s"];
    this.pemeriksaan_fisik = this.soap["o"];
    this.diagnosis = this.soap["a"];
    this.terapi = this.soap["p"];
    // } else
    if (value != null) {
      this.getSpri();
    }
    // console.log("watch mdal", this.soap)
  }
  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtd = false;
  }

  dokterList() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }
  getSpri() {
    appModule.setLoading(true);

    const dt = DataSpri.getDataSpri(this.register);
    dt.then(dt => {
      appModule.setLoading(false);
      this.dtSpri = dt;
    });
  }
  simpanSpri() {
    if (this.readOnly) return;
    // console.log("sv", this.dtSpri);
    appModule.setLoading(true);
    if (this.dtSpri["status"] == 1) {
      const dt = DataSpri.editDataSpri(
        this.dtSpri["data"][0]["id"],
        this.register,
        this.tanggal,
        this.keluhan_utama,
        this.riwayat_penyakit,
        this.pemeriksaan_fisik,
        this.pemeriksaan_penunjang,
        this.diagnosis,
        this.terapi,
        this.dpjp["id"],
        // this.dokter_id,
        this.sess_login["id"],
        this.sess_login["unit_id"]
      );
      dt.then(dt => {
        appModule.setLoading(false);

        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.$emit("respSpri", dt["data"]);
          // this.getSpri()

          // console.log(dt);
          this.modalTtd = true;
          storeSpri.act_spri_on_reg(this.register);
        }
      });
      this.dialog = false;
      // console.log('edit')
    } else {
      // console.log('simpan')
      const dt = DataSpri.saveDataSpri(
        this.register,
        this.tanggal,
        this.keluhan_utama,
        this.riwayat_penyakit,
        this.pemeriksaan_fisik,
        this.pemeriksaan_penunjang,
        this.diagnosis,
        this.terapi,
        this.dpjp["id"],
        // this.dokter_id,
        this.sess_login["id"],
        this.sess_login["unit_id"]
      );
      dt.then(dt => {
        appModule.setLoading(false);

        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.$emit("respSpri", dt["data"]);
          // this.getSpri()

          // console.log(dt);

          this.modalTtd = true;
          storeSpri.act_spri_on_reg(this.register);
        }
      });
      this.dialog = false;
    }
  }
  // @Watch('err')
  // change(value: object, oldValue: object) {
  //     // this.dtDokter = value
  //     // this.listDokter = this.listDokterUnit
  //     this.err=value
  //     // console.log(value)

  //     // this.changeDokter()
  // }
}
